import {FilteringGridWithBulkOperations} from './filtering_grid_with_bulk_operations.js';

export const EventsListView = Backbone.View.extend({
  el: '#event_list',
  initialize: function() {
    this.editable = this.options.editable;
    this.data = this.options.data.map(this.cleanEventData)
    this.tags = _.uniq(this.options.data.reduce(this.selectTags, []));
    this.userDateFormat = this.options.userDateFormat;
    this.settings = this.options.settings || { }
    this.savedSettings = this.settings.saved || { }

    this.initTagInputBoxes();
    this.initGrid();

    // there is a bug somewhere in slickgrid that is forcing us to do this twice on initialization to avoid having the last columns of the last row not appear.
    this.resizeGrid();
    this.resizeGrid();

    $(window).resize(_.debounce(() => {
      this.resizeGrid();
    }, 100));
  },
  events: {
    // filtering
    'click .toggle_filters': 'toggleFilters',
    'keyup .filter_by_name': 'filterTextInputChanged',
    'keyup .filter_by_location': 'filterTextInputChanged',
    'change .filter_by_tag': 'filtersChanged',
    // bulk operations
    'click .show_bulk_op': 'showBulkOp',
    'click .batch_set_visibility': 'batchSetVisibility',
    'click .batch_add_tags,.batch_remove_tags': 'batchUpdateTags',
    'click .batch_delete': 'batchDelete',
    'click .backup': 'batchBackup',
    'click .batch_archive': 'batchArchive',
    'click .batch_unarchive': 'batchUnarchive',
    // misc
    'click .grid_height_increase': 'increaseGridHeight',
    'click .grid_height_decrease': 'decreaseGridHeight'
  },
  initGrid: function() {
    const events = this.data,
      formatters = FilteringGridWithBulkOperations.formatters;

    // column definitions
    const columns = [
      {id:"name", name:T.t('event_name'), field:"name", sortable:true, formatter: formatters.eventName.bind(this), editor:Slick.Editors.Text},
      {id:"tags", name:'Tags', field:"tags", sortable:true, formatter: formatters.tags},
      {id:"starts_on", name:'Starts On', field:"starts_on", sortable:true, formatter: formatters.date.bind(this)},
      {id:"created_at", name:'Created', field:"created_at", sortable:true, formatter: formatters.date.bind(this)},
      {id:"num_routes", name:'Routes', field:"num_routes", sortable:true},
      {id:"location", name:T.t('location'), field:"location", sortable:true, editor:Slick.Editors.Text}
    ];
    if(this.editable) {
      columns.push(
        {id:"visibility", name:'Privacy', field:"visibility", sortable:true, formatter: formatters.visibility, editor:Slick.Editors.YesNoFriendsSelect, isClub: true}
      );
    }

    const columnWidths = Object.assign({
      tags: 170,
      starts_on: 90,
      created_at: 90,
      num_routes: 65,
      location: 125,
      visibility: 81
    }, this.savedSettings.columnWidths || {})
    columns.forEach(column => column.width = columnWidths[column.id])

    const nameFilter = this.$('.filter_by_name')
    const tagFilter = this.$('.filter_by_tag')
    const locationFilter = this.$('.filter_by_location')
    const filterAccessors = new Map(Object.entries({
      name: nameFilter.val.bind(nameFilter),
      tag_names: tagFilter.select2.bind(tagFilter, "val"),
      location: locationFilter.val.bind(locationFilter)
    }))

    this.grid = new FilteringGridWithBulkOperations(events, {
      target: '#events_table',
      columns: columns,
      editable: this.editable,
      updatePath: function(id) { return '/events/'+id+'/simple_update.json';},
      updateParam: 'event',
      viewPath: function(item) { return '/events/'+item.slug;},
      ignoreCaseOnSort: ['name', 'location'],
      filterAccessors: filterAccessors,
      settingsOpts: this.settings.opts
    });

    // case insensitive sort of concatenated tags
    this.grid.sortingFn('tags', (a, b) => {
      const x = (a.tag_names || []).join().toUpperCase(), y = (b.tag_names || []).join().toUpperCase();
      return (x==y ? 0 : (x > y ? 1 : -1));
    })

    var params = rwgps.Utils.getQueryParameters(window.location.search)
    var viewingArchives = params.archive === 'true'

    this.grid.enableFiltering([
      {field: 'name', type: 'string'},
      {field: 'tag_names', type: 'arraySubset'},
      {field: 'location', type: 'string'},
      {field: 'archived_at', type: 'function', extra: this.getFilterByViewingArchives(viewingArchives)}
    ]);

    this.grid.enableBulkOperations({
      bulkUpdateAttributePath: '/events/batch_set_attr.json',
      bulkDeletePath: '/events/batch_destroy.json',
      idsParam: 'event_ids'
    });

    if (this.savedSettings.sortCol) {
      this.grid.setSort(this.savedSettings.sortCol, this.savedSettings.sortAsc)
    }
  },

  /*
   * filtering
   */

  toggleFilters: function() {
    if (this.$('.toggle_filters .plus').is(':visible')) {
      this.showFilters()
    } else {
      this.hideFilters()
    }
  },

  showFilters: function() {
    this.$('.toggle_filters').find('.plus').hide().end().find('.minus').show();
    this.$('.filters').show();
  },

  hideFilters: function() {
    this.$('.toggle_filters').find('.plus').show().end().find('.minus').hide();
    this.$('.filters').hide();
  },

  filterTextInputChanged: function(e) {
    // clear on escape
    if(e.which == 27) e.currentTarget.value = '';
    this.filtersChanged()
  },

  filtersChanged: function() {
    if (this.grid) { this.grid.filterInputsChanged() }
  },

  getFilterByViewingArchives: function(viewingArchives) {
    return (item) => {
      if (viewingArchives) {
        return !!item.archived_at
      }
      if (!viewingArchives) {
        return !item.archived_at
      }
    }
  },

  /*
   * bulk operations
   */

  showBulkOp: function(e) {
    const bulkOp = $(e.currentTarget).attr('data-bulk-op');
    this.$('.bulk_op_' + bulkOp).toggle();
    return false;
  },

  batchSetVisibility: function() {
    const visVal = parseInt(this.$('select.visibility').val());
    this.grid.setAttributeOnSelectedItems('visibility', visVal);
  },

  batchArchive: function() {
    const items = this.grid.selectedItems;
    if(!items.length) {
      customAlert("No routes selected. Click the checkboxes next to the events you'd like to archive first.");
    } else {
      customConfirm('Are you sure? This will archive ' + items.length + ' selected event' + (items.length === 1 ? '' : 's'), () => (
        this.grid.setAttributeOnSelectedItems('archived_at', new Date()).always(() => {
          this.grid.setSelectedRows([]);
          this.filtersChanged();
        })
      ));
    }
    return false;
  },

  batchUnarchive: function() {
    const items = this.grid.selectedItems;
    if(!items.length) {
      customAlert("No routes selected. Click the checkboxes next to the events you'd like to unarchive first.");
    } else {
      customConfirm('Are you sure? This will unarchive ' + items.length + ' selected event' + (items.length === 1 ? '' : 's'), () => (
        this.grid.setAttributeOnSelectedItems('archived_at', null).always(() => {
          this.grid.setSelectedRows([]);
          this.filtersChanged();
        })
      ));
    }
    return false;
  },

  initTagInputBoxes: function() {
    this.$('.tag_select2_input').val('').select2({
      openOnEnter: false,
      width: '150px',
      placeholder: 'Event Tags',
      tokenSeparators: [','],
      tags: this.tags,
      selectOnBlur: true,
      formatNoMatches: function() { return ''; },
      createSearchChoice: (term) => {
        for (var value of this.tags) {
          if (value.toUpperCase() === term.toUpperCase()) {
            return {id: value, text: value};
          }
        }
        return {id: term, text: term}
      }
    });
  },

  batchDelete: function() {
    const items = this.grid.selectedItems;
    if(!items.length) {
      customAlert("No events selected. Click the checkboxes next to the events you'd like to delete first.");
    } else {
      customConfirm('Are you sure? This will delete ' + items.length + ' selected event' + (items.length === 1 ? '' : 's'), () => this.grid.deleteSelectedItems());
    }
    return false;
  },

  batchBackup: function() {
    const items = this.grid.selectedItems;
    if(!items.length) return false;

    customConfirm("Create a backup of the selected " + (items.length > 1 ? items.length + " events" : "event") + "?", () => {
      const ids = _.map(items, ({id}) => id);
      $.post('/user_backups', {user_backup: {format: 'json', content: {events: ids}}}, function(resp) {
        customAlert(resp.message);
      });
    })
    return false;
  },

  batchUpdateTags: function(e) {
    const tagsStr = this.$('input.tag_names').val();
    const isAdd = $(e.currentTarget).hasClass('batch_add_tags');
    const tagAction = isAdd ? 'add' : 'remove';

    if (tagsStr === '') {
      if(isAdd)
        customAlert('When adding tags, press &lt;enter&gt; after you type the tag, then click the Add Tags button.');
      else
        customAlert('When removing tags, press &lt;enter&gt; after you type the tag, then click the Remove Tags button.');
      return;
    }

    this.grid.remoteRequest({
      url: '/events/batch_update_tags.json',
      params: (selectedIds) => { return { event_ids: selectedIds.join(','), tag_action: tagAction, tag_names: tagsStr } },
      done: (dataView, data) => {
        dataView.beginUpdate()
        data.events.forEach((eventData) => {
          var event = dataView.getItemById(eventData.id)
          event.tag_names = eventData.tag_names
          dataView.updateItem(event.id, event)

          if (isAdd) {
            event.tag_names.forEach((tag) => {
              if (!this.tags.includes(tag)) {
                this.tags.push(tag)
                this.$('select.filter_by_tag').append('<option value="'+tag+'">'+tag+'</option>')
              }
            })
          }
        })
        dataView.endUpdate();
        this.$('input.tag_names').select2('val', '');
      }
    })
  },

  cleanEventData: function(data) {
    var event = Object.assign(data)
    event.created_at = rwgps.DateExt.parse(event.created_at)
    event.updated_at = rwgps.DateExt.parse(event.updated_at)
    return event
  },

  /*
   * misc
   */

  selectTags: function (accumulator, item) {
    return accumulator.concat(item.tag_names || [])
  },
  resizeGrid: function() {
    // Don't resize anything if sizes have been set by the user
    if (this.savedSettings.columnWidths) { return }

    let size = 0;
    let nameItem;
    _.each(this.grid.slickGrid.getColumns(), function(item) {
      if (item.id == "name")
        nameItem = item;
      else
        size += item.width;
    });
    nameItem.width = this.grid.slickGrid.getViewport().rightPx - size;
    this.grid.slickGrid.resizeCanvas();
    this.grid.slickGrid.autosizeColumns();
  },
  increaseGridHeight: function() {
    this.changeGridHeight(100);
  },
  decreaseGridHeight: function() {
    this.changeGridHeight(-100);
  },
  changeGridHeight(amount) {
    const $table = $('#events_table');
    let height = $table.height();
    if(height + amount < 100) return;
    height += amount;
    $table.height(height).trigger('resize');
    Application.setPreference("events_grid_height", height, true);
  }
});



// WEBPACK FOOTER //
// ./public/javascripts/clubs/events_list_view.js